import { useState } from "react";

export default function Testimonials() {
    const testimonials = [
        {
            name: "Ahmed Khan",
            country: "Pakistan",
            review:
                "Amazing stay! The hotel was spotless and the service was exceptional. Will definitely book again.",
            avatar: "https://i.pravatar.cc/100?img=12",
        },
        {
            name: "Sarah Johnson",
            country: "United Kingdom",
            review:
                "Found the best deal on Dubai Hotel Rates. Easy booking process and great customer support.",
            avatar: "https://i.pravatar.cc/100?img=47",
        },
        {
            name: "David Lee",
            country: "Australia",
            review:
                "Highly recommend! The location was perfect and the view was breathtaking.",
            avatar: "https://i.pravatar.cc/100?img=11",
        },
        {
            name: "Maria Wilson",
            country: "United States",
            review:
                "Everything was smooth from booking to check-in. Excellent hotel options and great prices.",
            avatar: "https://i.pravatar.cc/100?img=32",
        },
        {
            name: "Omar Hassan",
            country: "United Arab Emirates",
            review:
                "Very easy to compare hotels and find the right option. The whole experience was excellent.",
            avatar: "https://i.pravatar.cc/100?img=53",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    const visibleTestimonials = [
        testimonials[activeIndex % testimonials.length],
        testimonials[(activeIndex + 1) % testimonials.length],
        testimonials[(activeIndex + 2) % testimonials.length],
    ];

    const nextSlide = () => {
        setActiveIndex(
            (prev) => (prev + 1) % testimonials.length
        );
    };

    const prevSlide = () => {
        setActiveIndex(
            (prev) =>
                (prev - 1 + testimonials.length) %
                testimonials.length
        );
    };

    return (
        <section className="relative overflow-hidden bg-[#F3F8FF] py-14 sm:py-16 lg:py-18">

            {/* =====================================================
                BACKGROUND DECORATION
            ====================================================== */}
            <div className="pointer-events-none absolute -left-32 top-10 h-72 w-72 rounded-full bg-white opacity-70 blur-3xl" />

            <div className="pointer-events-none absolute -right-32 bottom-0 h-72 w-72 rounded-full bg-[#E4EFFF] opacity-80 blur-3xl" />

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

                {/* =================================================
                    SECTION HEADER
                ================================================== */}
                <div className="mx-auto mb-9 max-w-2xl text-center">

                    {/* Eyebrow */}
                    <div className="mb-2 flex items-center justify-center gap-2">
                        <span className="h-[2px] w-6 rounded-full bg-[#FFC928]" />

                        <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#174EA6]">
                            Guest Reviews
                        </span>

                        <span className="h-[2px] w-6 rounded-full bg-[#FFC928]" />
                    </div>

                    {/* Heading */}
                    <h2 className="text-2xl font-extrabold tracking-tight text-[#0F172A] sm:text-3xl lg:text-[32px]">
                        What Our{" "}
                        <span className="text-[#174EA6]">
                            Guests Say
                        </span>
                    </h2>

                    <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-slate-500">
                        See why travelers choose Dubai Hotel Rates for
                        their perfect stay in Dubai.
                    </p>
                </div>

                {/* =================================================
                    TESTIMONIAL CARDS
                ================================================== */}
                <div className="relative">

                    {/* Left Arrow */}
                    <button
                        onClick={prevSlide}
                        aria-label="Previous testimonial"
                        className="absolute -left-2 top-1/2 z-20 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-[#174EA6] shadow-[0_6px_20px_rgba(15,23,42,0.10)] transition-all duration-300 hover:-translate-x-1 hover:bg-[#174EA6] hover:text-white lg:flex"
                    >
                        <span className="text-lg">←</span>
                    </button>

                    {/* Cards */}
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">

                        {visibleTestimonials.map((testimonial, index) => (
                            <div
                                key={`${testimonial.name}-${activeIndex}`}
                                className={`group relative overflow-hidden rounded-2xl border bg-white p-5 shadow-[0_8px_30px_rgba(15,23,42,0.06)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_15px_35px_rgba(15,23,42,0.10)] ${index === 1
                                    ? "md:scale-[1.02]"
                                    : ""
                                    }`}
                            >

                                {/* Top gold accent */}
                                <div className="absolute left-0 right-0 top-0 h-[3px] bg-gradient-to-r from-[#174EA6] via-[#FFC928] to-[#174EA6]" />

                                {/* =================================================
                                    STARS
                                ================================================== */}
                                <div className="mb-3 flex items-center gap-1">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <svg
                                            key={star}
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            className="h-4 w-4 text-[#FFC928]"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l1.082 2.602a1.3 1.3 0 0 0 1.06.788l2.808.225c1.164.093 1.635 1.545.748 2.292l-2.144 1.805a1.3 1.3 0 0 0-.426 1.3l.654 2.773c.27 1.145-.964 2.056-1.96 1.448l-2.407-1.806a1.3 1.3 0 0 0-1.57 0l-2.407 1.806c-.996.608-2.23-.303-1.96-1.448l.654-2.773a1.3 1.3 0 0 0-.426-1.3L6.175 9.117c-.887-.747-.416-2.199.748-2.292l2.808-.225a1.3 1.3 0 0 0 1.06-.788l1.082-2.602Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    ))}

                                    <span className="ml-1 text-[10px] font-bold text-slate-400">
                                        5.0
                                    </span>
                                </div>

                                {/* =================================================
                                    QUOTE ICON
                                ================================================== */}
                                <div className="absolute right-5 top-5 text-[#EAF1FB]">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        className="h-10 w-10"
                                    >
                                        <path d="M9.17 6.41A5.5 5.5 0 0 0 4 12v.5h3.5A2.5 2.5 0 0 1 10 15v.5A2.5 2.5 0 0 1 7.5 18H4a2.5 2.5 0 0 1-2.5-2.5V12A8.5 8.5 0 0 1 9.17 4.08a1.2 1.2 0 0 1 0 2.33Z" />

                                        <path d="M21.17 6.41A5.5 5.5 0 0 0 16 12v.5h3.5A2.5 2.5 0 0 1 22 15v.5a2.5 2.5 0 0 1-2.5 2.5H16a2.5 2.5 0 0 1-2.5-2.5V12a8.5 8.5 0 0 1 7.67-7.92 1.2 1.2 0 0 1 0 2.33Z" />
                                    </svg>
                                </div>

                                {/* =================================================
                                    REVIEW
                                ================================================== */}
                                <p className="relative z-10 min-h-[72px] text-[13px] leading-6 text-slate-600">
                                    "{testimonial.review}"
                                </p>

                                {/* =================================================
                                    DIVIDER
                                ================================================== */}
                                <div className="my-4 h-px bg-slate-100" />

                                {/* =================================================
                                    USER
                                ================================================== */}
                                <div className="flex items-center gap-3">

                                    <img
                                        src={testimonial.avatar}
                                        alt={testimonial.name}
                                        className="h-10 w-10 rounded-full object-cover ring-2 ring-[#EEF5FF]"
                                    />

                                    <div>
                                        <h3 className="text-sm font-bold text-[#0F172A]">
                                            {testimonial.name}
                                        </h3>

                                        <div className="mt-0.5 flex items-center gap-1.5">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                className="h-3 w-3 text-[#174EA6]"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M11.54 22.351l.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.64 16.64 0 0 0 1.42-.969c.879-.683 1.88-1.647 2.864-2.76 1.933-2.188 3.79-5.083 3.79-8.122a8.535 8.535 0 0 0-17.07 0c0 3.04 1.857 5.934 3.79 8.122a30.5 30.5 0 0 0 4.284 3.729zM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>

                                            <span className="text-[10px] text-slate-400">
                                                {testimonial.country}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Bottom hover line */}
                                <div className="absolute bottom-0 left-1/2 h-[2px] w-0 -translate-x-1/2 bg-[#FFC928] transition-all duration-300 group-hover:w-16" />
                            </div>
                        ))}
                    </div>

                    {/* Right Arrow */}
                    <button
                        onClick={nextSlide}
                        aria-label="Next testimonial"
                        className="absolute -right-2 top-1/2 z-20 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-[#174EA6] shadow-[0_6px_20px_rgba(15,23,42,0.10)] transition-all duration-300 hover:translate-x-1 hover:bg-[#174EA6] hover:text-white lg:flex"
                    >
                        <span className="text-lg">→</span>
                    </button>
                </div>

                {/* =================================================
                    SLIDER DOTS
                ================================================== */}
                <div className="mt-7 flex items-center justify-center gap-2">
                    {testimonials.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setActiveIndex(index)}
                            aria-label={`Go to testimonial ${index + 1}`}
                            className={`h-2 rounded-full transition-all duration-300 ${index === activeIndex
                                ? "w-6 bg-[#174EA6]"
                                : "w-2 bg-slate-300 hover:bg-slate-400"
                                }`}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
}